import { useContext } from 'react';
import { CollectionContext } from '../contexts/CollectionContext';

// ----------------------------------------------------------------------

const useCollection = () => useContext(CollectionContext);

export default useCollection;